export default __webpack_public_path__ + "static/media/line_pr.549a80e5.png";